export const AnalyticsEventCategory = Object.freeze({
  balanceSheet: 'monitor-balance-sheet',
  capitalReport: 'capital',
  conversations: 'conversations',
  funding: 'funding',
  fundingAffordability: 'funding.affordability',
  fundingProfile: 'funding-profile',
  fundingProfileServiceability: 'funding-profile-serviceability',
  fundingReport: 'funding-report',
  fundingEnquiries: 'funding-enquiries',
  fundingSearchOffers: 'funding-search-offers',
  fundingSearchProfile: 'funding-search-profile',
  fundingSearchResponses: 'funding-search-responses',
  responses: 'responses',
  fundingSearchTimeline: 'funding-search-timeline',
  learning: 'learning',
  monitor: 'monitor',
  monitorSelect: 'monitor-select',
  monitorFilter: 'monitor-filter',
  monitorView: 'monitor-view', // NEW
  monitorConversations: 'monitor-conversations',
  navbarLaunch: 'navbar-launch',
  questionnaire: 'questionnaire',
  updateMatch: 'update-match',
  updateMatchStatus: 'update-match-status',
  profileResponsesPanel: 'profile-responses-panel',
  casesCreate: 'cases-create',
  casesFilter: 'cases-filter',
  casesSelect: 'cases-select',
  casesCase: 'cases-case',
  creditProfileScore: 'credit.profile-credit.score',
  creditProfileRiskFactors: 'credit.profile-risk.factors',
  creditProfilePaymentPerformance: 'credit.profile-payment.performance',
  creditProfile: 'credit.profile',
  credit: 'credit',
  applications: 'applications',
  application: 'application',
  company: 'company',
  user: 'user',
  business: 'business',
  today: 'today',
  sso: 'sso',
  risk: 'risk',
  profileApplication: 'profile-application',
  apiPartner: 'api-partner',
  monitorOnboard: 'monitor-onboard',
  personalisedOffers: 'personalised.offers',
  personalisedOffersDeselect: 'personalised.offers-deselect',
  personalisedOffersSelect: 'personalised.offers-select',
  personalisedOffersShow: 'personalised.offers-show',
  personalisedOffersStart: 'personalised.offers-start',
  personalisedOffersCompare: 'personalised.offers-compare',
  referral: 'referral',
  onboard: 'onboard',
  profile: 'profile',
  monitorHide: 'monitor-hide',
  monitorShow: 'monitor-show',
  invite: 'invite',
  inviteClient: 'invite.client',
  signup: 'signup',
});

export const AnalyticsEventAction = Object.freeze({
  archiveModalStart: 'related-archive.start',
  archiveModalCancel: 'related-archive.cancel',
  archiveModalComplete: 'related-archive.complete',
  client: 'client',
  clientStart: 'client-start',
  addClientImport: 'add.client-import', // Confirm
  activityDismiss: 'activity-dismiss',
  analysisStart: 'analysis-start', // Confirm
  analysisMapping: 'analysis-mapping', // Confirm
  analysisPreview: 'analysis-preview', // Confirm
  analysisComplete: 'analysis-complete', // Confirm
  completed: 'completed',
  connectCompleted: 'connect-completed', // Confirm
  connectInitiate: 'connect-initiate', // Confirm
  connectMatch: 'connect-match',
  connectRedirect: 'connect-redirect', // Confirm
  connectSnapshot: 'connect-snapshot',
  conversationsCloseSuggesion: 'close-suggestion',
  conversationsCollapse: 'collapse-tray',
  conversationsExpandCard: 'expand-card',
  conversationsExpand: 'expand-tray',
  conversationsViewClients: 'view-clients',
  profileConnectInitiate: 'connect-initiate',
  profileConnectStart: 'connect-start', // Confirm
  courseViewed: 'course-viewed',
  creditReportRequest: 'credit-report-request',
  creditReportStart: 'credit-report-start',
  requestedCreditScore: 'requested-credit-score',
  dashboard: 'dashboard',
  delete: 'delete',
  print: 'print',
  skip: 'skip',
  answered: 'answered',
  close: 'close',
  documentDownloaded: 'document-downloaded',
  documentSubmitted: 'document-submitted',
  documentUploaded: 'document-uploaded',
  feedbackAwaitingClient: 'feedback-awaiting-client',
  feedbackAwaitingDocuments: 'feedback-awaiting-documents',
  feedbackCancelSearch: 'feedback-cancel-search',
  feedbackContinueWithOffer: 'feedback-continue-with-offer',
  feedbackDeclineOffer: 'feedback-decline-offer',
  feedbackDocumentsReceived: 'feedback-documents-received',
  launchAnalysePortfolio: 'analyse-portfolio',
  launchCreateFundingReport: 'create-funding-report',
  launchCBILS: 'cbils',
  launchDownloadCreditReport: 'download-credit-report',
  launchFundingSearch: 'funding-search',
  launchHealthReport: 'health-report',
  launchDebtRecovery: 'debt-recovery',
  launchMonitorClient: 'monitor-client',
  launchShareContent: 'share-content',
  launchReportDashboard: 'report-dashboard',
  launchRecoveryLoan: 'recovery-loan',
  learningViewed: 'learning-accessed',
  lessonCompleted: 'lesson-completed',
  lessonStarted: 'lesson-started',
  modalBcc: 'modal-bcc',
  modalCancelSearch: 'modal-cancel-search',
  modalDeleteSearch: 'modal-delete-search',
  modalRemoveUser: 'modal-remove-user',
  modalRequestFundingSearchHelp: 'modal-request-funding-search-help',
  modalUploadDocument: 'modal-upload-document',
  modalContinue: 'modal-continue',
  modalClose: 'modal-close',
  modalFundingAmount: 'modal-funding.amount',
  modalTerm: 'modal-term',
  modalRevenue: 'modal-revenue',
  modalContactNumber: 'modal-contact.number',
  all: 'all',
  details: 'details',
  application: 'application',
  monitorFilterLaunch: 'filter-launch',
  monitorFilterClose: 'filter-close',
  monitorFilterClear: 'filter-clear',
  monitorFilterSelect: 'filter-select',
  newFundingSearch: 'new-funding-search',
  offerReportOpened: 'offer-report-opened',
  offerReportUpdated: 'offer-report-updated',
  offerReportPrinted: 'offer-report-printed',
  offerReportPrimarySummaryEdit: 'offer-report-primary-summary-edit',
  offerReportLenderSummaryEdit: 'offer-report-lender-summary-edit',
  offersViewed: 'offers-history-viewed',
  profile: 'profile',
  profileDocumentRemove: 'profile-document-removed',
  profileDocumentUpload: 'profile-document-uploaded',
  profileLeadAccepted: 'lead-accepted',
  profileLeadPassed: 'lead-passed',
  profileViewed: 'profile-viewed',
  profileUpdated: 'profile-updated',
  searchStarted: 'search-started',
  searchSubmitted: 'search-submitted',
  statusUpdated: 'status-updated',
  submitted: 'funding-search-submitted',
  updatedMatchStatus: 'updated-match-status',
  viewBalanceSheet: 'view-balance-sheet',
  viewed: 'viewed',
  view: 'view',
  viewFacilities: 'view-facilities',
  viewProfile: 'profile-view',
  navViewCreditProfile: 'nav-view.credit.profile',
  navViewApplications: 'nav-view.applications',
  navViewMonitor: 'nav-view.monitor',
  driverMonitor: 'driver-monitor',
  profileToggleBank: 'profile-toggle.bank',
  profileToggleCredit: 'profile-toggle.credit',
  profileViewBank: 'profile-view.bank.account',
  profileViewCredit: 'profile-view.credit.account',
  profileReportDownload: 'profile.report-download',
  profileAboutThisData: 'profile-about.this.data',
  profileSettingsOpen: 'profile-settings.open',
  profileSettingsCancelSearch: 'profile.settings-cancel.search',
  profileSettingsRemoveSearch: 'cancel.search-remove.search',
  profileFacilitiesAlertDismiss: 'profile.facilities-alert.dismiss',
  profileFacilitiesAlertFindOutMore: 'profile.facilities-alert.find.out.more',

  hideSection: 'hide-section',
  resumeFundingSearch: 'resume-funding-search',
  showSection: 'show-section',
  viewFundingSearch: 'view-funding-search',
  manualOfferOpened: 'manual-offer-opened',
  instantOfferOpened: 'instant-offer-opened',
  takeActionCreateFundingReport: 'take-action-create-funding-report',
  takeActionStartFundingReport: 'take-action-start-funding-search',
  takeActionMarkComplete: 'take-action-mark-complete',
  takeActionCloseEnquiry: 'take-action-close-enquiry',

  serviceabilityView: 'view',
  serviceabilityCalculations: 'show-calculations',
  serviceabilityTerm: 'edit-term',
  serviceabilityRate: 'edit-rate',
  serviceabilityFacility: 'edit-facility',
  serviceabilityPeriod: 'edit-period',
  serviceabilityEbitda: 'edit-ebitda',
  serviceabilityDividends: 'edit-dividends',
  serviceabilityRepayments: 'edit-repayments',
  serviceabilityChange: 'request-change',
  serviceabilityContinue: 'continue',

  casesCreateNew: 'new',
  casesFilters: 'filters',
  casesSelectCase: 'case',
  casesCaseView: 'view',
  modalCancelCase: 'cancel',
  modalDeleteCase: 'delete',

  shareReport: 'report-share.report',
  shareCopy: 'report.share-copy.link',
  shareView: 'report.share-view.link',

  reportDownload: 'report.download',
  reportDownloadError: 'report.download-error',

  signupStart: 'report.signup-start',
  signupLogin: 'report.signup-login',
  signupComplete: 'report.signup-complete',
  signupCompleteWidget: 'signup-complete',

  businessSignupStart: 'signup-start',
  businessSignupComplete: 'signup-complete',
  businessPersonalDetailsComplete: 'signup-user.details.complete',
  businessPersonalDetailsStart: 'signup-personal.details.start',
  businessCompanyDetailsStart: 'signup-company.details.start',
  businessCompanyDetailsComplete: 'signup-company.details.complete',
  signupError: 'signup-error',
  businessSignupLogin: 'signup-login',

  reportView: 'report-view',
  reportResync: 'report-connection.resync',
  reportDisconnect: 'report-connection.disconnect',
  reportNavigate: 'report-connection.navigate',
  reportExpandInsight: 'report-insight.expand',
  reportPerformanceToggle: 'report.business.performance-toggle.period',
  reportCashToggle: 'report.cash.capital-toggle.period',
  reportEditFacilities: 'report.existing.facilities-edit.facilities',
  reportConfirmFacilities: 'report.existing.facilities-confirm',
  reportChangeExistingFacilities: 'report.existing.facilities-change',
  reportPaymentOverdueFilter: 'report.payments.overdue-filter',
  reportPaymentOverdueExpandDebtor: 'report.payments.overdue-expand.debtor',
  insight: 'insights',
  expandCategory: 'expand.category',
  sort: 'sort',
  profileView: 'profile-view',
  profileChange: 'profile-request.change',
  profileExpand: 'profile-expand',
  profileLogout: 'profile-logout',
  profileSummaryCreditScore: 'profile.summary-credit.score',
  profileSummaryCashCapital: 'profile.summary-cash.capital',
  profileSummaryRiskFactors: 'profile.summary-risk.factors',
  profileCreditSearches: 'profile.credit-searches',
  profileSummaryPaymentPerformance: 'profile.summary-payment.performance',
  profileSummaryLegalNotices: 'profile.summary-legal.notices',
  annualAccountsExpandTable: 'annual.accounts-expand.table',

  onBoardingDismiss: 'onboarding-dismiss',
  onBoardingDone: 'onboarding-done',
  onBoardingCompleteStep: 'onboarding-complete.step',
  onBoardingCollapse: 'onboarding-collapse',

  viewUpdate: 'view.update',
  viewInsight: 'view.insight',
  viewWhatChangedUpdate: 'whats.changed-view.update',

  profileBalanceSheetView: 'profile-balance.sheet.view',
  profileProfitLossView: 'profile-profit.loss.view',
  profileFacilitiesView: 'profile-facilities.view',
  profileInsightsView: 'profile-insights.view',
  profileInsightsExpand: 'profile-insights.expand',
  profileInsightStartApplication: 'profile-insight.start.application',
  profileNotesView: 'profile-notes.view',
  clientAccessView: 'client-access.view',
  profileCapitalReportView: 'profile-capital.report.view',
  profileActionsCapitalReportView: 'profile-actions.capital.report.view',
  profileActionsEditDetails: 'profile-actions.edit.details',
  profileActionsArchiveClient: 'profile-actions.archive.client',
  profileActionsDeleteClient: 'profile-actions.delete.client',
  profileAssignClientManager: 'profile-assign.client.manager',
  clientActionsCapitalReportView: 'client.actions-capital.report.view',
  clientActionsEditDetails: 'client.actions-edit.details',
  clientActionsArchiveClient: 'client.actions-archive.client',
  clientActionsDeleteClient: 'client.actions-delete.client',
  segmentConversation: 'segment-conversation',
  segmentTags: 'segment-tags',
  segmentSector: 'segment-sector',
  segmentCreditScore: 'segment-credit.score',
  segmentYearEnd: 'segment-year.end',
  segmentCompanySize: 'segment-company.size',
  segmentLiquidity: 'segment-liquidity',
  segmentInisights: 'segment-insights',
  monitorExport: 'monitor-export',
  monitorView: 'monitor-view',
  upgradeStart: 'upgrade-start',
  upgradePayMonthly: 'upgrade-pay.monthly',
  upgradePayAnnually: 'upgrade-pay.annually',
  upgradeSwitchPlan: 'upgrade-switch.plan',
  upgradeShowFeatures: 'upgrade-show.features',
  upgradeContinue: 'upgrade-continue',
  upgradeClose: 'upgrade-close',
  upgradeComplete: 'upgrade-complete',
  upgradeDirectorUpdateDetails: 'upgrade.director.info-update.details',

  importFile: 'add.customers-import.file',
  importManually: 'add.customers-search.company',

  creditHistory: 'profile-view.credit.history',

  reviewFindOutMore: 'review-find.out.more',
  reviewChat: 'review-chat',
  reviewContinue: 'review-continue',
  reviewComplete: 'review-complete',
  reviewConfirmationChat: 'review.confirmation-chat',

  minimiseConversations: 'minimise-conversations',
  segmentDate: 'segment-date',
  conversationGuide: 'conversation-guide',

  tryNowCompany: 'try.now-search.company',
  tryNowImportFile: 'try.now-import.file',
  searchCompanyClose: 'search.company-close',
  searchCompanyImport: 'search.company-import',
  searchCompanyDelete: 'search.company-delete.customer',
  searchCompanySelect: 'add.company-select.search.company',
  searchCompanySearch: 'add.company-search.company',
  emptyMonitorImportFile: 'monitor-add.company',
  emptyMonitorImportCompany: 'monitor-search.company',
  importFileClose: 'add.company-close',
  importFileImport: 'add.company-import',
  importFileDeleteCompany: 'add.company-delete.company',
  importFileUploadFile: 'add.company-upload.file',

  verifyError: 'upgrade.director.info-verify.error',
  personalStart: 'upgrade.director.info-personal.details.start',
  personalComplete: 'upgrade.director.info-personal.details.complete',
  addressStart: 'upgrade.director.info-director.address.start',
  addressComplete: 'upgrade.director.info-director.address.complete',
  verifyDetails: 'upgrade.director.info-verify.details',

  relatedCreditFile: 'related-credit.file',
  profileViewProfileBreakdown: 'profile.summary-view.credit.profile',
  profileViewCompanyInformation: 'profile.summary-view.company.info',
  profileViewInsights: 'profile-view.insights',
  profileInsightsViewRisks: 'profile.insights-view.risks',
  profileViewNegativeFactors: 'profile.insights-view.negative.factors',
  sectionContinue: 'section-continue',
  directorDetailsAddNew: 'director.details-add.new',
  directorDetailsRemoveApplicant: 'director.details-remove.applicant',
  directorDetailsCompleteDetails: 'director.details-complete.details',
  resubmitLenders: 'resubmit-lenders',
  directorSkip: 'director-skip',
  submitApplication: 'submit-application',
  selectLenders: 'select-lenders',
  deselectLenders: 'deselect-lenders',
  documentUpload: 'document.upload',
  documentDelete: 'document.delete',
  lender: 'lender',
  lenderSubmissionEnabled: 'lender-submission.enabled',
  lenderSubmissionShown: 'lender-submission.lenders-shown',
  lenderSubmissionSubmitted: 'lender-submission.submitted',
  sidebarClicked: 'sidebar-clicked',
  tabSwitched: 'tab-switched',

  responsesView: 'responses-view',
  responsesCompleteApplication: 'responses-complete.application',
  reviewStart: 'review-start',

  addClientManual: 'add.client-manual',
  addClientSelect: 'add.client.select',
  addClientRemove: 'add.client.remove',
  addClientSubmit: 'add.client.submit',

  clientCancel: 'client-cancel',
  clientComplete: 'client-complete',
  selectPlanNoPlans: 'select.plan-no.plans',
  selectPlanContinue: 'select.plan-continue',
  managePreferencesContinue: 'manage.preferences-continue',
  clientPermissionContinue: 'client.permission-continue',
  clientPermissionPrevious: 'client.permission-previous',
  clientInviteCopyLink: 'client.invite-copy.link',

  viewToggleFinancial: 'view-toggle.financial',
  viewToggleRiskProfile: 'view-toggle.risk-profile',

  creditLimitReached: 'client-limit-reached',

  inviteClient: 'invite-client',
  shareCopyLink: 'share-copy.link',
  updateMatchStatus: 'update-match-status',
  segmentSearch: 'search',

  consentStart: 'consent-start',
  consentPersonalComplete: 'consent.personal.details-complete',
  consentAddressComplete: 'consent.address.details-complete',
  consentVerify: 'consent-verify.details',
  consentError: 'consent-error',
  consentComplete: 'consent-error',

  chart: 'chart',

  applicationDriverDismiss: 'application.driver-dismiss',
  applicationDriverFindOutMore: 'application.driver-find.out.more',
  applicationDriverComparePlans: 'application.driver-compare.plans',

  creditReviewDriverFindOutMore: 'company.details-driver.find.out.more',
  creditReviewDriverDismiss: 'company.details-driver.dismiss',
  eligibilityStart: 'eligibility-start',
  eligibilityComplete: 'eligibility-complete',
  eligibilityChange: 'eligibility-change',
  setBudget: 'budget-set.budget',
  completeBudget: 'budget-complete',
  borrowingSetTerm: 'borrowing-set.term',
  borrowingSetAmount: 'borrowing-set.amount',
  borrowingComplete: 'borrowing-complete',

  googleStart: 'google.start',
  emailStart: 'email.start',

  consentSkip: 'consent-skip',
  open: 'open',

  recommendedProductsFindOutMore: 'recommended.products-driver-find.out.more',
  recommendedProductsStartCRS: 'recommended.products-start.CRS',
});

export const AnalyticsIntegratedFrom = Object.freeze({
  fundingProfile: 'funding.profileHeader',
  estimatedServiceability: 'funding.estimatedServiceability',
  tradeHistory: 'funding.tradingHistory',
  monitorHub: 'monitor.hub',
});

export const ConnectionSource = Object.freeze({
  monitorTable: 'client-table',
  monitorProfile: 'client-profile',
  monitorCapitalReport: 'capital-report',
});

export const AnalyticsServices = Object.freeze({
  all: 3,
  googleAnalytics: 0,
  intercom: 1,
  mixpanel: 2,
});

export const AnalyticsDataMonitorFilters = Object.freeze({
  previewSector: {
    action: AnalyticsEventAction.segmentSector,
    payloadKey: 'sector',
    toLowerCase: false,
  },
  creditScore: {
    action: AnalyticsEventAction.segmentCreditScore,
    payloadKey: 'creditscore',
    toLowerCase: true,
  },
  endFinancialYear: {
    action: AnalyticsEventAction.segmentYearEnd,
    payloadKey: 'yearEnd',
    toLowerCase: false,
  },
  size: {
    action: AnalyticsEventAction.segmentCompanySize,
    payloadKey: 'companySize',
    toLowerCase: true,
  },
  liquidity: {
    action: AnalyticsEventAction.segmentLiquidity,
    payloadKey: 'liquidity',
    toLowerCase: true,
  },
});
